import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const { FiSun, FiHome, FiSettings } = FiIcons;

const WhyWe = () => {
  const { t } = useLanguage();

  const reasons = [
    {
      icon: FiSun,
      title: t('whyWe.localRaw.title'),
      description: t('whyWe.localRaw.desc'),
      details: t('whyWe.localRaw.details'),
    },
    {
      icon: FiHome,
      title: t('whyWe.ownProducts.title'),
      description: t('whyWe.ownProducts.desc'),
      details: t('whyWe.ownProducts.details'),
    },
    {
      icon: FiSettings,
      title: t('whyWe.preserveKnowledge.title'),
      description: t('whyWe.preserveKnowledge.desc'),
      details: t('whyWe.preserveKnowledge.details'),
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-gray-800 mb-8">
            {t('whyWe.title')}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="card-custom bg-white rounded-lg shadow-lg p-6 text-center"
            >
              <div className="mb-6">
                <div className="w-16 h-16 bg-accent-green rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon
                    icon={reason.icon}
                    className="w-8 h-8 text-white"
                  />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  {reason.title}
                </h3>
              </div>
              <p className="text-gray-600 mb-4">
                {reason.description}
              </p>
              <p className="text-gray-600 text-sm">
                {reason.details}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyWe;